import { makeAutoObservable } from "mobx";
import RmaPageStore from "./rma-page-store";
import rmaPagedListStore from "../../rma-list-page/stores/rma-paged-list-store";
import { IIframeService } from "../../../../services/iframe-service/iframe-service";
import { TYPE, rootContainer } from "../../../../services/container/root";

function isIndexInArray(index:number, arr:object[]): boolean {
	if (index < 0) {
		return false;
	}
	return index >= 0 && index <= arr.length - 1;
}

export class RmaPageMainStore {
	private _currentRmaPageStore?: RmaPageStore;
	private _mapOfUpdatedRmas: { [rmaId: number]: boolean } = {};

    constructor() {
		makeAutoObservable(this, {}, { autoBind: true });
	}

	private get iframeService(): IIframeService {
		return rootContainer.get<IIframeService>(TYPE.IframService);
	}

	public setRmaPageStore(rmaId: number): void {
		if (this._currentRmaPageStore?.rmaId !== rmaId) {
			this._currentRmaPageStore = new RmaPageStore(this, rmaId);
			this._currentRmaPageStore.loadRma();
		}
		this.iframeService.navigateReturns({ rmaid: rmaId });
	}

	public getRmaPageStore(): RmaPageStore|undefined {
		return this._currentRmaPageStore;
	}

	public getUpdatedRmas(): number[] {
		return (Object.keys(this._mapOfUpdatedRmas) as unknown) as number[];
	}

	public addUpdatedRmaId(rmaId: number): void {
		this._mapOfUpdatedRmas[rmaId] = true;
	}

	public clearUpdatedRmaIds(): void {
		this._mapOfUpdatedRmas = {};
	}

	public get nextRmaId(): undefined|number {
		const foundIndex = rmaPagedListStore.list.findIndex(i => i.rmaId === this._currentRmaPageStore?.rmaId);
        if (foundIndex === -1) {
            return undefined;
        }
        const nextIndex = foundIndex + 1;
		return isIndexInArray(nextIndex, rmaPagedListStore.list) ? rmaPagedListStore.list[nextIndex].rmaId : undefined;
	}

	public get prevRmaId(): undefined|number {
		const foundIndex = rmaPagedListStore.list.findIndex(i => i.rmaId === this._currentRmaPageStore?.rmaId);
        if (foundIndex === -1) {
            return undefined;
        }
		const prevIndex = foundIndex - 1;
		return isIndexInArray(prevIndex, rmaPagedListStore.list) ? rmaPagedListStore.list[prevIndex].rmaId : undefined;
	}
    
}
export default new RmaPageMainStore();
